export interface AppAccount {
  id: string;
  email: string;
  name: string;
  organizationId?: string;
  organizationName?: string;
  status: 'active' | 'suspended' | 'pending';
  lastLoginAt?: string;
  createdAt: string;
  updatedAt: string;
}

export const mockAppAccounts: AppAccount[] = [
  {
    id: 'acc-1',
    email: 'john.doe@techinnovations.com',
    name: 'John Doe',
    organizationId: 'org-1',
    organizationName: 'Tech Innovations Inc.',
    status: 'active',
    lastLoginAt: '2024-01-30T10:30:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-30T10:30:00Z'
  },
  {
    id: 'acc-2',
    email: 'jane.smith@digitalmarketing.com',
    name: 'Jane Smith',
    organizationId: 'org-2',
    organizationName: 'Digital Marketing Agency',
    status: 'active',
    lastLoginAt: '2024-01-29T15:45:00Z',
    createdAt: '2024-01-05T00:00:00Z',
    updatedAt: '2024-01-29T15:45:00Z'
  },
  {
    id: 'acc-3',
    email: 'mike.wilson@startupcorp.com',
    name: 'Mike Wilson',
    organizationId: 'org-3',
    organizationName: 'StartupCorp',
    status: 'active',
    lastLoginAt: '2024-01-28T09:15:00Z',
    createdAt: '2024-01-10T00:00:00Z',
    updatedAt: '2024-01-28T09:15:00Z'
  },
  {
    id: 'acc-4',
    email: 'sarah.johnson@enterprise.com',
    name: 'Sarah Johnson',
    organizationId: 'org-4',
    organizationName: 'Enterprise Solutions Ltd.',
    status: 'suspended',
    lastLoginAt: '2024-01-20T14:20:00Z',
    createdAt: '2023-12-01T00:00:00Z',
    updatedAt: '2024-01-30T00:00:00Z'
  },
  {
    id: 'acc-5',
    email: 'alex.brown@creativestudio.com',
    name: 'Alex Brown',
    organizationId: 'org-5',
    organizationName: 'Creative Studio',
    status: 'active',
    lastLoginAt: '2024-01-30T11:00:00Z',
    createdAt: '2024-01-12T00:00:00Z',
    updatedAt: '2024-01-30T11:00:00Z'
  },
  {
    id: 'acc-6',
    email: 'lisa.davis@freelancer.com',
    name: 'Lisa Davis',
    status: 'pending',
    createdAt: '2024-01-29T00:00:00Z',
    updatedAt: '2024-01-29T00:00:00Z'
  }
];

export const findAppAccountById = (id: string): AppAccount | undefined => {
  return mockAppAccounts.find(account => account.id === id);
};